/* eslint-disable new-cap,no-new */
import debounce from 'lodash/debounce';

import {humanReadableStringToAddress} from '../helpers/humanReadableStringToAddress';
import {transliterateUmlauts} from '../helpers/transliterateUmlauts';
import {addressToHumanReadableString} from '../helpers/addressToHumanReadableString';
import {escapeRegExp} from '../helpers/escapeRegExp';

const dataAttribute = 'data-id';

const KEY_ENTER = 13;
const KEY_ARROW_UP = 38;
const KEY_ARROW_DOWN = 40;

const outputElement = document.getElementById('search-output');
const buttonElement = document.getElementById('search-button');
const inputElement = document.getElementById('street');

function getSuggestions() {
	const query = inputElement.value;
	const address = humanReadableStringToAddress(query);

	if (address.street) {
		const streetRegexString = escapeRegExp(transliterateUmlauts(address.street));
		const streetMatcherStarting = new RegExp('^' + streetRegexString, 'i');
		const streetMatcherAnywhere = new RegExp('.+' + streetRegexString, 'i');

		const matchesStarting = window.AGSOZ_STREET_NAMES.filter(streetName => streetMatcherStarting.test(transliterateUmlauts(streetName)));
		const matchesAnywhere = window.AGSOZ_STREET_NAMES.filter(streetName => streetMatcherAnywhere.test(transliterateUmlauts(streetName)));

		const results = [...matchesStarting, ...matchesAnywhere]
			.slice(0, 20)
			.map(street => {
				address.street = street;
				return addressToHumanReadableString(address);
			});

		if (results.length > 1 || (results.length === 1 && !address.number)) {
			inputElement.classList.add('agsoz-input--with-auto-complete');
			return results;
		}
	}

	inputElement.classList.remove('agsoz-input--with-auto-complete');
	return [];
}

if (inputElement) {
	const resultsList = document.createElement('ul');
	resultsList.setAttribute('id', 'agsoz-auto-complete__result-list');
	resultsList.className = 'agsoz-auto-complete__result-list';
	inputElement.insertAdjacentElement('afterend', resultsList);
	inputElement.addEventListener('input', debounce(() => {
		const suggestions = getSuggestions();
		const queryValue = inputElement.value.toLowerCase();
		resultsList.innerHTML = '';

		if (queryValue.trim().length) {
			const fragment = document.createDocumentFragment();
			const list = [];
			suggestions.forEach((record, index) => {
				const result = document.createElement('li');
				result.setAttribute(dataAttribute, index);
				result.className = 'agsoz-auto-complete__result';
				result.innerHTML = record;
				resultsList.appendChild(result);
				list.push({index: index, value: record});
			});
			resultsList.appendChild(fragment);
			const li = resultsList.childNodes;
			const liLength = li.length - 1;
			let liSelected = undefined;
			let next;

			const removeSelection = direction => {
				liSelected.classList.remove('agsoz-auto-complete__result--selected');

				if (direction === 1) {
					next = liSelected.nextSibling;
				} else {
					next = liSelected.previousSibling;
				}
			};

			const highlightSelection = current => {
				liSelected = current;
				liSelected.classList.add('agsoz-auto-complete__result--selected');
			};

			const getDataForLi = el => {
				const id = Number(el.getAttribute(dataAttribute));
				return list.find(value => value.index === id);
			};

			// Keyboard action
			inputElement.addEventListener('keydown', event => {
				function handleUp() {
					// Prevent cursor relocation
					event.preventDefault();
					if (liSelected) {
						removeSelection(0);
						if (next) {
							highlightSelection(next);
						} else {
							highlightSelection(li[liLength]);
						}
					} else {
						highlightSelection(li[liLength]);
					}
				}

				function handleDown() {
					if (liSelected) {
						removeSelection(1);
						if (next) {
							highlightSelection(next);
						} else {
							highlightSelection(li[0]);
						}
					} else {
						highlightSelection(li[0]);
					}
				}

				function handleSelect() {
					if (liSelected) {
						const data = getDataForLi(liSelected);
						if (data && data.value) {
							inputElement.classList.remove('agsoz-input--with-auto-complete');
							inputElement.value = data.value;
							inputElement.focus();
							liSelected.classList.remove('agsoz-auto-complete__result--selected');
							liSelected = undefined;
						}
					}
				}

				if (li.length > 0) {
					switch (event.keyCode) {
						case KEY_ARROW_UP:
							handleUp();
							break;

						case KEY_ARROW_DOWN:
							handleDown();
							break;

						case KEY_ENTER:
						default:
							handleSelect();
					}
				}
			});

			li.forEach(selection => {
				selection.addEventListener('mousedown', ({currentTarget}) => {
					const data = getDataForLi(currentTarget);
					if (data && data.value) {
						inputElement.classList.remove('agsoz-input--with-auto-complete');
						inputElement.value = data.value;
						inputElement.focus();

						setTimeout(() => {
							inputElement.focus();
							inputElement.selectionStart = inputElement.selectionEnd = inputElement.value.length;
						}, 10);
					}
				});
			});
		}
	}, 100));

	inputElement.addEventListener('keyup', function check() {
		const newValue = inputElement.value;
		const newAddress = humanReadableStringToAddress(newValue);

		if (!newAddress.street) {
			outputElement.innerHTML = 'Bitte geben Sie eine Adresse ein!';
			buttonElement.disabled = true;
			return;
		}

		if (!newAddress.number) {
			outputElement.innerHTML = 'Bitte geben Sie eine <strong>Hausnummer</strong> an!';
			buttonElement.disabled = true;
			return;
		}

		outputElement.innerHTML = '';
		buttonElement.disabled = false;
	});
}
